import apiService from '@/api/apiService';

export const logout = async () => {
    const url = '/api/admin/logout';

    return apiService.POST(url, {});
};
